<template>
  <div class="page-content_wrapper download">
    <panel title="模板下载" icon="assets/images/icon-template.png">
      <div v-loading="loading">
        <template v-if="list.length > 0">
          <bids-download
            v-for="(item, index) in list"
            :key="index"
            button-text="【标书下载】"
            :value="item"
          />

          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :current-page="pagination.current"
            :page-size="pagination.size"
            :total="pagination.total"
            @current-change="pageChange"
          />
        </template>

        <empty-layout v-else />
      </div>
    </panel>
  </div>
</template>

<script>
import Panel from '@/components/Panel'
import EmptyLayout from '@/components/EmptyLayout'
import BidsDownload from '@/components/BidsDownload'

import { fetchTemplate } from '@/api'

export default {

  components: {
    Panel,
    EmptyLayout,
    BidsDownload
  },
  data() {
    return {
      list: [],

      pagination: {
        current: 1,
        size: 10,
        total: 0
      },

      loading: false
    }
  },

  mounted() {
    this.fetchTemplate()
  },

  methods: {
    /*
     * 获取模板下载
    */
    async fetchTemplate(page = 1) {
      this.loading = true

      try {
        const res = await fetchTemplate({
          pageSize: this.pagination.size,
          pageNo: page
        })

        this.list = res.data.records
        this.pagination.total = res.data.total
      } catch (error) {
        this.$message.error(error.message)
      }

      this.loading = false
    },

    pageChange(page) {
      document.documentElement.scrollTop = 0

      this.fetchTemplate(page)
    }
  }
}
</script>

<style lang='scss' scoped>
.download {
  padding-bottom: 61px;
  .bids-download {
    padding: 20px 0;
    border-bottom: 1px solid #F0F0F0;
  }
  .el-pagination {
    display: table;
    margin: 63px auto 0;
  }
}
</style>
